import './styles.scss'

const cards = Array.from({ length: 8 })

export function ProductsSkeleton() {
  return (
    <div
      className="card-banner-section-items-list products-results-skeleton"
      aria-busy="true"
      aria-live="polite"
    >
      {cards.map((_, i) => (
        <div key={i} className="product-card-skeleton">
          <div className="product-card-skeleton__image" />
          <div className="product-card-skeleton__content">
            <span className="product-card-skeleton__title" />
            <span className="product-card-skeleton__title product-card-skeleton__title--short" />
          </div>
        </div>
      ))}
    </div>
  )
}
